import { favorite, requestState } from "../actions/index";

export default (initialState, action) => {
	switch (action.type) {
		case requestState.LOADING:
			return {
				...initialState,
				loading: true,
			};

		case favorite.ADD_TO_FAVORITE:
			return {
				...initialState,
				loading: false,
				success: "Course added to favorites",
				favorites: [action.payload, ...initialState.favorites],
			};
		case favorite.GET_FAVORITES:
			return {
				...initialState,
				favorites: action.payload,
				loading: false,
			};
		case favorite.REMOVE_FROM_FAVORITE:
			return {
				...initialState,
				loading: false,
				success: "Course remoded from favorites",
				favorites: initialState.favorites.filter((favorite) => favorite._id !== action.payload),
			};
		case requestState.ERROR:
			return {
				...initialState,
				loading: false,
				error: action.payload,
			};

		case favorite.FILTER_FAVORITE:
			return {
				...initialState,
				favoriteFilter: initialState.favorites.filter((item) => {
					//console.log(item);
					const regex = new RegExp(`${action.payload}`, "gi");
					if (item.lesson.title.match(regex)) {
						return item;
					} else {
						return null;
					}
				}),
			};
		
		case favorite.CLEAR_FILTER: 
			return {
				...initialState,
				favoriteFilter : null
			}

		case requestState.CLEAR_NOTIFICATION:
			return {
				...initialState,
				error: null,
				success: null,
			};
		default:
			return initialState;
	}
};
